import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=e13d9cc6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\riverside\\project\\mall\\skill-supply\\skill-supply-mall-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e13d9cc6"]])

export default __exports__